import { render, staticRenderFns } from "./userDept.vue?vue&type=template&id=73069b99&scoped=true"
import script from "./userDept.vue?vue&type=script&lang=js"
export * from "./userDept.vue?vue&type=script&lang=js"
import style0 from "./userDept.vue?vue&type=style&index=0&id=73069b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73069b99",
  null
  
)

export default component.exports